/**
 * CinematicWedding — immersive wedding microsite experience.
 *
 * A full-page experience template that renders couple storytelling, family
 * tree, multiple wedding events with maps, pre-wedding media gallery, and an
 * RSVP section. The actual UI is owned by CinematicWeddingExperience; this
 * module's job is to register the template in the frontend registry under the
 * canonical ID `tpl_cinematic_wedding_001` so that:
 *
 *   1. PublicInvitation.tsx routes to it via `registry.has(templateId)`.
 *   2. TemplateRenderer renders it by ID without any ad-hoc `if` branches.
 *   3. The registry ID matches the DB row from migration
 *      20260606000000_fix_cinematic_wedding_id_add_lagna_patrika.
 *
 * NOTE: The old id 'tpl_wedding_classic_001' was incorrectly reused (PR #61).
 * That row is now deactivated in the DB. This new id is the correct, immutable
 * canonical id for this template going forward.
 */

import React from 'react';
import { CinematicWeddingExperience } from '@/src/modules/experiences/wedding/CinematicWeddingExperience';
import { registry } from '../registry';
import type { InvitationData, TemplateMetadata } from '../types';

const META: TemplateMetadata = {
  id: 'tpl_cinematic_wedding_001',
  name: 'Cinematic Wedding Experience',
  occasionType: 'WEDDING',
  description:
    'Immersive wedding microsite with couple storytelling, family tree, events, maps, and pre-wedding media.',
  isPremium: true,
  tags: ['cinematic', 'wedding', 'storytelling', 'premium'],
  colorScheme: { primary: '#d7b56d', accent: '#f0d894', bg: '#11130f' },
};

export function CinematicWedding({ data }: { data: InvitationData }) {
  return <CinematicWeddingExperience data={data} />;
}

registry.register({ metadata: META, component: CinematicWedding });
